import React from "react";
import { connect } from "react-redux";
import { Typography, LinkText } from "../ecosystem/";


const SchedulingQuestions = ({ engageHelpDeskNumber, textAlign }) => {
    return <div className="scheduling-questions">
        <Typography
            type="body-03"
            bold
            tag="div"
            textAlign={textAlign}
        >
            <span>Have scheduling questions?</span>
            <span>Call{' '}
            <LinkText
                typographyType="body-03"
                href={"tel:" + engageHelpDeskNumber}
                decorator="mobile"
                bold={true}
            >
                {engageHelpDeskNumber}
                </LinkText>
            </span>
        </Typography>
    </div>
}

const mapStateToProps = state => {
    return {
        engageHelpDeskNumber: state.session.serverData?.engageHelpDeskNumber || '833.466.3020'
    }
}

export default connect(mapStateToProps)(SchedulingQuestions);